<template>
	<Container>
		<Subtitle>
			{{ $t('office') }}
		</Subtitle>
		<div class="p-4">
			<div class="lg:flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<div class="mb-4">
						<label class="block mb-2">{{ $t('Nombre') }}</label>
						<input
							type="text"
							v-model="office.office_name"
							class="
								mt-2
								w-full
								border-t-0
								border-r-0
								border-l-0
								border-b
								border-solid
								border-inputGrey
								outline-none
							"
						/>
						<div v-if="$v.office.office_name.$dirty">
							<div
								class="text-sm text-red-500 mt-2"
								v-if="!$v.office.office_name.required"
							>
								{{ $t('Campo_requerido') }}
							</div>
						</div>
					</div>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('street') }}</label>
					<input
						type="text"
						v-model="office.street"
						class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
				</div>
			</div>
			<div class="lg:flex">
				<div class="lg:w-1/3 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('number') }}</label>
					<input
						type="text"
						v-model="office.number"
						class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
				</div>
				<div class="lg:w-1/3 mb-4 lg:pl-2 pr-2">
					<label class="block mb-2">{{ $t('floor') }}</label>
					<input
						type="text"
						v-model="office.floor"
						class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
				</div>
				<div class="lg:w-1/3 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('door') }}</label>
					<input
						type="text"
						v-model="office.door"
						class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
				</div>
			</div>
			<div class="lg:flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('city') }}</label>
					<input
						type="text"
						v-model="office.city"
						class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('state') }}</label>
					<select
						v-model="office.state_id"
						class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					>
						<option
							v-for="(state, index) in states"
							:value="state.id"
							:key="index"
						>
							{{ state.name }}
						</option>
					</select>
					<div v-if="$v.office.state_id.$dirty">
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.office.state_id.required"
						>
							{{ $t('Campo_requerido') }}
						</div>
					</div>
				</div>
			</div>
			<div class="lg:flex">
				<div class="lg:w-1/3 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('zipcode') }}</label>
					<input
						type="text"
						v-model="office.zipcode"
						class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
				</div>
			</div>
			<div class="lg:flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('Telefono') }}</label>
					<input
						type="text"
						v-model="office.phone"
						class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('email') }}</label>
					<input
						type="text"
						v-model="office.email"
						class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
				</div>
			</div>
			<div class="flex justify-end">
				<ButtonBlack class="mt-4" @click.native="submit">
					<div v-if="loading">
						<pulse-loader
							:loading="loading"
							:color="'#fff'"
							:size="'10px'"
						></pulse-loader>
					</div>
					<div v-else>
						{{ buton_text }}
					</div>
				</ButtonBlack>
			</div>
			<div v-if="error" class="mt-4">
				<p class="text-sm">{{ $t('server_error') }}</p>
				<p class="text-sm text-red-500" v-html="server_error"></p>
			</div>
		</div>
	</Container>
</template>

<script>
import { single } from '@/mixins'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { required, maxLength } from 'vuelidate/lib/validators'
import { fetchStatesSelect } from '@/apollo/states'

import gql from 'graphql-tag'

export default {
	mixins: [single],
	components: {
		PulseLoader
	},
	apollo: {
		states: fetchStatesSelect(),
		office: {
			query: gql`
				query ($office_id: bigint!) {
					organizations_offices_by_pk(id: $office_id) {
						office_name
						address
						state_id
						phone
						email
						number
						street
						floor
						door
						city
						zipcode
					}
				}
			`,
			variables() {
				return {
					office_id: this.id
				}
			},
			update(data) {
				return {
					...data.organizations_offices_by_pk
				}
			}
		}
	},
	data() {
		return {
			office: {
				office_name: '',
				address: '',
				state_id: null,
				phone: '',
				email: '',
				number: '',
				street: '',
				floor: '',
				door: '',
				city: '',
				zipcode: ''
			},
			states: []
		}
	},
	validations() {
		return {
			office: {
				office_name: {
					required,
					maxLength: maxLength(50)
				},
				state_id: {
					required
				},
				street: {
					maxLength: maxLength(100)
				}
			}
		}
	},
	props: {
		delegation_id: String
	}
}
</script>
